import React, { useEffect, useState } from 'react';
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import { Button, Grid, Paper, Table, TableBody } from '@mui/material';
import ReferanceDocumentsHD from '../components/referanceDocumentsHD';
import ReferenceDocumentList from '../components/referenceDocumentList';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import ReferenceDocummentsCRU from '../components/referenceDocummentsCRU';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { deleteReferenceDocumentApi, getReferenceDocumentsApi } from '../apiServices';
import { checkApiStatus } from '../../../utils';
import { useParams } from 'react-router-dom';
import { ShowAttachments } from '../../../shared_elements/components';
import { enqueueSnackbar } from 'notistack';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../shared_elements/actionCreators';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import { RoleBaseAccess } from '../../../hoc';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 183px)';

const ReferenceDocuments = () => {
    const dispatch=useDispatch()
    const { leaseSlug } = useParams();
    const { fileUploadDetails, leaseBasicDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [referenceDocumentInfo, setReferenceDocumentInfo] = useState({ list: [], pagination: null });
    const [addEditReferenceDocument, setAddEditReferenceDocument] = useState({mode: "", modal: false, data: null});
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [loading, setLoading] = useState(false);
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [sortConfig, setSortConfig] = useState({ field: "", direction: "" });
    const [uploadfile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const [deleteReferenceDocument, setDeleteRefeerenceDocument] = useState({mode: '', modal: false, data: null});
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: "", type: "" });
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})
    
    useEffect(() => {
        const uploadedFileData = getApiResponse("reference_document", slug);
        setUploadFileProgressData({uploadedFileData});
        trackActivity('Page Viewed',{ page_title: 'Reference Documents'})
    },[])
    useEffect(() => {
        if (!leaseBasicDetails?.status) return;
        getReferenceDocumentData("skeletonLoader", {per_page: 50});
    }, [leaseBasicDetails?.status]);

    const getReferenceDocumentData = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getReferenceDocumentsApi(params, query), {})
        .then(response => {
            if (checkApiStatus(response)) {
                setReferenceDocumentInfo(response?.data?.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"reference_document"}))
    }

    const onRequestSort = (event, property) => {
        const isAscending = sortConfig.field === property && sortConfig.direction === "asc";
        const newDirection = isAscending ? "desc" : "asc";
        setSortConfig({ field: property, direction: newDirection });
        getReferenceDocumentData('fetch', {
            page: referenceDocumentInfo?.pagination?.current_page || 1,
            per_page: referenceDocumentInfo?.pagination?.per_page || 10,
            sort: newDirection,
            sort_by: property,
        });
    };

    const handelDeleteAttachment = (deleteSlug) => {
        setUploadfile({
            ...uploadfile,
            data: { ...uploadfile.data, attachments: uploadfile.data.attachments.filter(item => item.slug !== deleteSlug) }
        });
        getReferenceDocumentData("fetch", { page: referenceDocumentInfo?.pagination?.current_page || 1, per_page: referenceDocumentInfo?.pagination?.per_page || 50, });
    }

    const handelDelete = () => {
        setLoading(true);
        const idsToDelete = deleteReferenceDocument?.modal && deleteReferenceDocument?.data?.id ? [deleteReferenceDocument?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteReferenceDocumentApi(params), { ids: idsToDelete })
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Reference Document`, success_msg: response?.data?.message, item_ids: deleteReferenceDocument?.data || bulk?.ids, response: response?.data })
                    setDeleteRefeerenceDocument({ data: null, modal: false });
                    setBulk({ modal: false, ids: [], wrkGrpSlug: "" })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    getReferenceDocumentData("fetch", {
                        page: referenceDocumentInfo?.pagination?.current_page || 1,
                        per_page: referenceDocumentInfo?.pagination?.per_page || 50,
                    });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    trackActivity('Item Deleted', { page_title: `Delete Reference Document`, error_msg: response?.data?.message, item_ids: deleteReferenceDocument?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === "bulk") {
                setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
        } catch (error) {
            console.error("Error fetching Data!", error);
        }
    }
    
    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
            await fileUpload({
                  attachments: fileUploadDetails.attachments,
                  module_name: "reference_document",
                 slug: slug,
                 query: { record_action_type: mode },
                 onStart: () => setLoading(true),
                 onComplete: () => setLoading(false),
                 onProgress: ({ progressRefs, attachments,response }) => {
                 setUploadFileProgressData({ progressRefs, attachments,response });
            },
            onSuccess: (success_msg) => {
              enqueueSnackbar(success_msg, { variant: "success" });
              getReferenceDocumentData("", { per_page: referenceDocumentInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
             enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error" });
            }
        });
       setSlug({})
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Reference Documents`, page_type: page_type, })
    }
  return (
    <>
        <LeasesBasicDetails />
        <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
            <LeasesNav />
            {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
            <div className='lease-details-content'>
                <Paper square className="responsive-paper">
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                            <BackToLeaseList/>
                        </Grid>
                    <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{padding:'0px',float:'right'}}>
                                <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                  {
                                      bulk?.type && bulk?.ids?.length ?
                                          <>
                                              <li className='lease-mobile-button'>
                                                  <Button onClick={() => {setBulk({ modal: false, ids: [], title: '', type: '' });handleItemClicked('Bulk Delete Cancel Button')}} size="small" variant="outlined" color="primary">Cancel</Button>
                                              </li>
                                              <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['D'] }}>
                                                  <li className='lease-mobile-button'>
                                                      <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                  </li>
                                              </PermissionWrapper>
                                          </> : null
                                  }
                                  <PermissionWrapper extraProps={{application: "lease_revamp", feature: "reference_document", operationType: ['C']}}>
                                      <li className='lease-mobile-button'>
                                          <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' color='primary' variant='contained' size='small' onClick={() => { setAddEditReferenceDocument({ modal: true, mode: 'add', data: { name: '', description: '', validity_start_date: "", validity_end_date: "" } }); handleItemClicked('Add Item Button') }}>Add Reference Documents</Button>
                                      </li>
                                  </PermissionWrapper>
                              </ul>
                          </Grid>
                    </Grid>
                  </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: referenceDocumentInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <ReferanceDocumentsHD
                                    onRequestSort={onRequestSort}
                                    sortConfig={sortConfig}
                                    item={referenceDocumentInfo?.list}
                                    bulk={bulk}
                                    toggleBulkOps={toggleBulkOps}
                                    />
                                  <TableBody>
                                      {referenceDocumentInfo?.list?.length > 0 && referenceDocumentInfo.list.map((item, index) => {
                                             const uploadedFileData = getApiResponse("reference_document", item?.slug);
                                        return (
                                            <ReferenceDocumentList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onView={() => setAddEditReferenceDocument({ modal: true, mode: "view", data: item })}
                                                onEdit={() => setAddEditReferenceDocument({ modal: true, mode: 'edit', data: item, })}
                                                viewFile={() => setUploadfile({ modal: true, mode: "file", data: item })}
                                                onDelete={() => {
                                                    setDeleteRefeerenceDocument({ modal: true, data: item });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                toggleBulkOps={toggleBulkOps}
                                                bulk={bulk}
                                            />
                                        )
                                    }) }
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && !referenceDocumentInfo?.list?.length && <NoRecordFound />}
                    </div>
                    <Paper>
                        <Pagination
                            pagination={referenceDocumentInfo?.pagination}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getReferenceDocumentData('pageLoader', { page: 1, per_page: perPage, ...(sortConfig?.field ? { sort_by: sortConfig.field, sort: sortConfig.direction } : {}) }); }}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getReferenceDocumentData('pageLoader', { page: pageNum, per_page: referenceDocumentInfo?.pagination?.per_page, ...(sortConfig?.field ? { sort_by: sortConfig.field, sort: sortConfig.direction } : {}) }); }}
                        />
                    </Paper>
                </Paper>
            </div>}
        </Paper>
        {
            addEditReferenceDocument?.modal ?
            <ReferenceDocummentsCRU 
            fileUpload={handleUpload}
             onToggleModal={() => setAddEditReferenceDocument({ ...addEditReferenceDocument, mode: "", modal: false, data: null })}
             referenceDocumentInfo={referenceDocumentInfo}
             getReferenceDocumentData={getReferenceDocumentData}
             modeType={addEditReferenceDocument?.mode}
             addEditReferenceDocument={addEditReferenceDocument}
             openAttachment={() => setUploadfile({ modal: true, data: addEditReferenceDocument?.data,mode:'view' })}
             params={params}
             getResponseBack={() => {getReferenceDocumentData('pageLoader', {
                page: referenceDocumentInfo?.pagination?.page || 1,
                per_page: referenceDocumentInfo?.pagination?.per_page || 10
            }); setBulk({modal: false, ids: [], type: '', title: ''})}} /> : null
        }
        {
            uploadfile.modal ?
                <ShowAttachments
                    getResponseBack={handelDeleteAttachment}
                    attachmentsData={uploadfile}
                    toggleModalFn={() => setUploadfile({ model: false, data: null,mode:'' })}
                    moduleName="Reference Documents"
                    url='delete-attachment'
                    permissionKey="lease_details"
                    onViewDisabled={addEditReferenceDocument?.mode === 'view' || uploadfile?.mode==='view'}
                /> : null
        }
        {
            deleteReferenceDocument.modal ? <DeletePopUp
                modal={deleteReferenceDocument.modal}
                title="Delete Reference Document"
                content={`Are you sure, you want to Delete ?`}
                onToggleModal={() => {
                    setDeleteRefeerenceDocument({ modal: false, data: null });
                    setBulk({modal: false, ids: [], type: ''});
                }}
                onDeleteRecords={() => handelDelete()} /> : null
        }
        {
            bulk.modal ? <DeletePopUp
                modal={bulk.modal}
                content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? "these" : "this"} records?`}
                title={`Delete ${bulk?.ids?.length === (referenceDocumentInfo?.list?.length || 0) ? "All Reference Documents" : "Selected Reference Documents"}`}
                onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
                onDeleteRecords={() => handelDelete()} /> : null
        }
         <FileUploadLayout
          uploadFileStatus={uploadFileStatus}
          open={uploadFileStatus?.modal}
          setUploadFileStatus={setUploadFileStatus}
          uploadFileProgressData={uploadFileProgressData}
          progressRefs={uploadFileProgressData?.progressRefs}
          attachments={uploadFileProgressData?.attachments}
          onDownloadComplete={()=> setSlug({})}
        />
        {
            revisionHistory.modal &&  
                  <RevisionHistory 
                   moduleName={"reference_document"}
                   revisionHistory={revisionHistory}
                   onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                  />
        }
        {loading ? <PageLoader /> : null}
    </>
  )
}
export default RoleBaseAccess(ReferenceDocuments, { application: 'lease_revamp', feature: 'reference_document', operationType: ['R'] });
